import React, { PropsWithChildren, ReactNode } from 'react';

export const ButtonGroup = ({ children }: PropsWithChildren<ReactNode>) => {
  return (
    <div
      className='flex flex-col my-8 space-y-4 sm:space-y-2 md:flex-row md:justify-end md:space-x-2 md:space-y-0'
      data-testid='button-group'
    >
      {children}
    </div>
  );
};
